




















































































import { ADMIN_TYPE } from "@/common/constant";
import User from "@/model/user";
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import userApi from "@/api/userApi";
import store from "@/store";

const authStore = namespace("Auth");
const cartStore = namespace("Cart");
@Component({
  name: "QCustomerNav",
})
export default class QCustomerNav extends Vue {
  @authStore.Getter
  getUserLogging!: User;

  @authStore.Getter
  loggingName!: string;

  @authStore.Getter
  getUserType!: string;

  @cartStore.Getter
  totalItems!: number;

  get showMyPage(): boolean {
    return this.getUserType && this.getUserType != ADMIN_TYPE;
  }

  get isAdmin(): boolean {
    return this.getUserType == ADMIN_TYPE;
  }

  gotoCart() {
    if (this.totalItems && !this.isAdmin) {
      this.$router.push({ name: "customer.carts" });
    }
  }

  public async logout() {
    try {
      const result = await userApi.logout();
      if (result.status === 200) {
        store.dispatch("Auth/logout");
      }
    } catch (error) {
      console.log(error);
    }
  }
}
